import React from 'react';
import './FormSelect.css';
import Dialog from '../Dialog';

export default function FormSelectImage(props) {

	const x = props.x;

	const [content, setContent] = React.useState('');
	const reference = React.useRef(null);
	const classes = (typeof props.classes === 'undefined') ? '' : props.classes;

	const wafId = props.wafId;
	const id = props.id;
	const dialogId = id + '-dialog';

	x.waf.init(wafId);
	x.waf[wafId][id] = {};
	x.waf[wafId][id].show = show;
	x.waf[wafId][id].hide = hide;

	React.useEffect(() => {
		(typeof props.makeContent == 'undefined') ? makeContent(reference.current.value) : props.makeContent('');
	}, [props, reference]);

	// Erlaubt es einem Aufrufer, den Filter von außen zu steuern (z.B. Tippen im
	// Composer statt im eigenen Suchfeld dieses Dialogs), ohne den Fokus zu verändern.
	React.useEffect(() => {
		if (typeof props.externalFilter === 'string') {
			reference.current.value = props.externalFilter;
			setContent(props.makeContent(props.externalFilter));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.externalFilter]);

	function show(event, showSelection = false) {
		event.preventDefault();
		reference.current.value = '';
		setContent(props.makeContent(''));
		// Fokus ueber Dialogs eigenen onAfterRender-Callback statt setTimeout/direkt
		// hier: show() wird u.a. synchron aus dem onChange eines ANDEREN Inputs heraus
		// aufgerufen (":"-Trigger im Composer), an dessen laufendem Input-Event der
		// Browser danach den Fokus sonst wieder zurueckriss. Ein setTimeout(0) war
		// dabei nicht zuverlaessig genug (das Element war zu dem Zeitpunkt teils noch
		// per display:none unsichtbar, da React den d-block-Klassenwechsel noch nicht
		// committed hatte) - onAfterRender feuert dagegen garantiert erst NACHDEM
		// Dialog.js den Sichtbarkeits-State tatsaechlich gerendert hat.
		x.wad[dialogId].show(() => {
			if (props.autoFocus !== false) reference.current.focus();
		});
	}

	function hide() {
		x.wad[dialogId].hide();
	}

	function onChange(event) {
		reference.current.value = event.target.value;
		setContent(props.makeContent(event.target.value));
	}

	function makeContent() {

	}

	const inputTag =
		<input
			id={id}
			type="text"
			ref={reference}
			className="form-control "
			onChange={onChange}
		/>


	return (
		<Dialog id={dialogId} x={x} classes={`select-image ${classes}`} title={inputTag} >
			<div id={'result-' + id} className='image-selection'>
				<span className={``}>{content}</span>
			</div>
		</Dialog>
	)
};
